// extracted by mini-css-extract-plugin
module.exports = {"SettingControl":"SettingControl_SettingControl__2RWUo","Label":"SettingControl_Label__1Mugb","TooHot":"SettingControl_TooHot__1McqK","TooCold":"SettingControl_TooCold__qLHik"};